import Icon from "@/components/ui/Icon";
import type { LinkProps } from "next/link";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { memo } from "react";

type AdvantagesButtonLinkProps = {} & React.ComponentProps<"a"> & LinkProps;

const AdvantagesButtonLink = ({
  className,
  href = "#",
  children,
}: AdvantagesButtonLinkProps) => {
  return (
    <Link
      href={href}
      className={cn(
        "group text-semantic-text-primary flex-auto min-w-0 flex gap-2 rounded-2xl border bg-white items-center justify-between text-lg leading-[130%] py-[19.2] px-6 md:py-4 cursor-pointer lg:text-gray-800 lg:text-lg lg:leading-[150%] transition-[box-shadow,border-color] border-blue-200 hover:border-[#2783FF] hover:shadow-[0px_8px_16px_0_rgba(0,0,0,0.08)]",
        className
      )}
    >
      <span className="flex-auto min-w-0">{children}</span>
      <Icon id="icon-arrow-right-lg_24" width={24} height={24} className="shrink-0 text-black lg:text-blue-500 transform rotate-90" />
    </Link>
  );
};

export default memo(AdvantagesButtonLink);
